import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UserSerivice } from "../services/user.service";
import { ConfigService } from "../core/services/config.service";
import { MsalService } from "@azure/msal-angular";
import { WantedcreditService } from "../services/wantedcredit.service";
@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.css"],
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;

  canEditAccount = false;

  constructor(readonly userSerivice: UserSerivice, private authService: MsalService,
    private wantedCreditService: WantedcreditService, private route: ActivatedRoute,
  private configService: ConfigService) { }
  ngOnInit(): void {
    this.userSerivice.currentProfile().subscribe((p) => (this.canEditAccount = !!p));
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  get enableOfferLink(): boolean {
    const programCount = Number(localStorage.getItem("prgmCount"));
    return programCount != null &&
      programCount != undefined &&
      !isNaN(programCount) &&
      programCount >= 1
      ? true
      : false;
  }

  get showOffsetPayments(): boolean { return this.canEditAccount && this.configService.enableOffsetPayments; }

  logout() {
    this.authService.logoutRedirect();
    this.wantedCreditService.clearRequestId();
  }
}
